export const persistedName = "project_qa_site_site_installation_new";
